import React, { useEffect, useState } from 'react';
import { referansDonemApi, tanimlarApi } from '../services/api';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

const aktifYil = new Date().getFullYear();
const yilSecenekleri = Array.from({ length: 6 }, (_, i) => aktifYil - i);

export default function ReferansDonem() {
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [kayitlar, setKayitlar]     = useState<any[]>([]);
  const [yukleniyor, setYukleniyor] = useState(false);

  // Toplu onay
  const [topluYil, setTopluYil]   = useState(aktifYil);
  const [topluAy, setTopluAy]     = useState('');
  const [topluMesaj, setTopluMesaj] = useState('');
  const [topluHata, setTopluHata]   = useState('');
  const [topluYuk, setTopluYuk]     = useState(false);

  // Tekil form (opsiyonel override)
  const [tekForm, setTekForm] = useState({ isletme_id: '', yil: aktifYil, referans_ay: '' });
  const [tekMesaj, setTekMesaj] = useState('');
  const [tekHata, setTekHata]   = useState('');

  // Filtre
  const [filtre, setFiltre] = useState({ isletme_id: '', yil: '' });

  useEffect(() => {
    tanimlarApi.isletmelerListesi(true).then(r => setIsletmeler(r.data));
    yukle();
  }, []);

  const yukle = () => {
    setYukleniyor(true);
    referansDonemApi.liste().then(r => setKayitlar(r.data)).finally(() => setYukleniyor(false));
  };

  const topluOnayla = async () => {
    setTopluHata(''); setTopluMesaj('');
    if (!topluAy) { setTopluHata('Ay seçiniz'); return; }
    if (!window.confirm(`${topluYil} yılı için tüm işletmelere ${AYLAR[Number(topluAy)]} ayı referans dönem olarak atansın mı?`)) return;
    setTopluYuk(true);
    try {
      const res = await axios.post(`${API}/api/referans-donem/toplu`,
        { yil: topluYil, referans_ay: Number(topluAy) },
        { headers: headers() }
      );
      setTopluMesaj(`${res.data.islenen} işletme için ${AYLAR[res.data.referans_ay]} onaylandı`);
      yukle();
    } catch (e: any) {
      setTopluHata(e.response?.data?.detail || 'Hata oluştu');
    } finally {
      setTopluYuk(false);
    }
  };

  const tekKaydet = () => {
    setTekHata(''); setTekMesaj('');
    if (!tekForm.isletme_id || !tekForm.referans_ay) { setTekHata('İşletme ve ay seçiniz'); return; }
    referansDonemApi.kaydet({
      isletme_id: Number(tekForm.isletme_id),
      yil: Number(tekForm.yil),
      referans_ay: Number(tekForm.referans_ay),
    }).then(() => {
      setTekMesaj('Kaydedildi');
      setTekForm({ isletme_id: '', yil: aktifYil, referans_ay: '' });
      yukle();
    }).catch(e => setTekHata(e.response?.data?.detail || 'Hata'));
  };

  const isletmeAd = (id: number) => isletmeler.find(i => i.id === id)?.ad || `#${id}`;

  const gorunen = kayitlar.filter(k => {
    if (filtre.isletme_id && k.isletme_id !== Number(filtre.isletme_id)) return false;
    if (filtre.yil && k.yil !== Number(filtre.yil)) return false;
    return true;
  });

  return (
    <div>
      <div className="page-header">
        <h1>📅 Referans Dönem Yönetimi</h1>
        <p>Dashboard ve raporlarda gösterilecek ayı belirler. Geçmiş yıllarda kayıt yoksa Aralık varsayılandır.</p>
      </div>

      {/* Toplu Onay - Ana Panel */}
      <div className="card" style={{ borderLeft: '4px solid #2c5f2e', marginBottom: 20 }}>
        <h3 style={{ marginTop: 0, marginBottom: 16 }}>Tüm İşletmeleri Onayla</h3>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div className="form-group" style={{ margin: 0 }}>
            <label>Yıl</label>
            <select className="form-control" style={{ width: 100 }} value={topluYil}
              onChange={e => setTopluYil(Number(e.target.value))}>
              {yilSecenekleri.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label>Referans Ay</label>
            <select className="form-control" style={{ width: 160 }} value={topluAy}
              onChange={e => setTopluAy(e.target.value)}>
              <option value="">Ay seçiniz...</option>
              {AYLAR.slice(1).map((ad, i) => <option key={i + 1} value={i + 1}>{ad}</option>)}
            </select>
          </div>
          <button className="btn btn-success" style={{ fontSize: 15, padding: '8px 28px' }}
            onClick={topluOnayla} disabled={topluYuk}>
            {topluYuk ? 'İşleniyor...' : `Tüm İşletmeleri Onayla`}
          </button>
        </div>
        {topluHata && <div className="alert alert-danger" style={{ marginTop: 12 }}>{topluHata}</div>}
        {topluMesaj && <div className="alert alert-success" style={{ marginTop: 12 }}>{topluMesaj}</div>}
      </div>

      {/* Tekil Override */}
      <details style={{ marginBottom: 20 }}>
        <summary style={{ cursor: 'pointer', padding: '10px 16px', background: '#f8f9fa', borderRadius: 6, border: '1px solid #dee2e6', fontSize: 14, fontWeight: 500 }}>
          Tek İşletme İçin Ayarla (İstisna)
        </summary>
        <div style={{ padding: '16px', border: '1px solid #dee2e6', borderTop: 'none', borderRadius: '0 0 6px 6px' }}>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label>İşletme</label>
              <select className="form-control" style={{ width: 220 }} value={tekForm.isletme_id}
                onChange={e => setTekForm(f => ({ ...f, isletme_id: e.target.value }))}>
                <option value="">Seçiniz...</option>
                {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
              </select>
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Yıl</label>
              <input className="form-control" type="number" style={{ width: 100 }} value={tekForm.yil}
                onChange={e => setTekForm(f => ({ ...f, yil: Number(e.target.value) }))} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Referans Ay</label>
              <select className="form-control" style={{ width: 140 }} value={tekForm.referans_ay}
                onChange={e => setTekForm(f => ({ ...f, referans_ay: e.target.value }))}>
                <option value="">Seçiniz...</option>
                {AYLAR.slice(1).map((ad, i) => <option key={i + 1} value={i + 1}>{ad}</option>)}
              </select>
            </div>
            <button className="btn btn-primary" onClick={tekKaydet}>Kaydet</button>
          </div>
          {tekHata && <div className="alert alert-danger" style={{ marginTop: 10 }}>{tekHata}</div>}
          {tekMesaj && <div className="alert alert-success" style={{ marginTop: 10 }}>{tekMesaj}</div>}
        </div>
      </details>

      {/* Filtre + Tablo */}
      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8 }}>
            <select className="search-input" style={{ width: 220 }} value={filtre.isletme_id}
              onChange={e => setFiltre(f => ({ ...f, isletme_id: e.target.value }))}>
              <option value="">Tüm İşletmeler</option>
              {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
            </select>
            <input type="number" className="search-input" style={{ width: 100 }} value={filtre.yil}
              onChange={e => setFiltre(f => ({ ...f, yil: e.target.value }))}
              placeholder="Yıl" />
          </div>
          <span style={{ fontSize: 13, color: '#666' }}>{gorunen.length} kayıt</span>
        </div>

        {yukleniyor ? (
          <div style={{ padding: 20, color: '#999', textAlign: 'center' }}>Yükleniyor...</div>
        ) : (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>İşletme</th><th>Yıl</th><th>Referans Ay</th><th>Güncelleme</th>
                </tr>
              </thead>
              <tbody>
                {gorunen.length === 0 && (
                  <tr><td colSpan={4} style={{ textAlign: 'center', color: '#999', padding: 20 }}>Kayıt bulunamadı</td></tr>
                )}
                {gorunen.map(k => (
                  <tr key={k.id}>
                    <td><strong>{isletmeAd(k.isletme_id)}</strong></td>
                    <td>{k.yil}</td>
                    <td>
                      <span style={{
                        background: k.yil === aktifYil ? '#fff3cd' : '#d1e7dd',
                        padding: '2px 10px', borderRadius: 12, fontSize: 13
                      }}>
                        {AYLAR[k.referans_ay]} ({k.referans_ay})
                      </span>
                    </td>
                    <td style={{ color: '#666', fontSize: 13 }}>
                      {k.guncelleme_tarihi ? new Date(k.guncelleme_tarihi).toLocaleDateString('tr-TR') : '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div style={{ marginTop: 16, padding: 12, background: '#e7f3ff', borderRadius: 6, fontSize: 13, color: '#0c5460' }}>
        <strong>Bilgi:</strong> Kaydı olmayan geçmiş yıllar için sistem otomatik olarak <strong>Aralık (12)</strong> ayını kullanır.
        Aktif yıl için kayıt yoksa dashboard <strong>uyarı</strong> gösterir.
      </div>
    </div>
  );
}
